// Types
import { GetMediaPosts_getMediaPosts_entities } from 'api/mediaPost/types/GetMediaPosts';
// Helpers
import { getStreamerName } from 'helpers/streams';
import { getLocaleDate } from 'helpers/mediaPost';
// Constants
import {
  ATHLETES,
  SOCIAL_MEDIA_POST,
  VIDEO_SOCIAL_MEDIA_POST,
} from 'constants/routes';
// Ui
import ContentCard, { ContentType } from 'ui3/Card/ContentCard';

type MediaFeedListItemProp = {
  mediaPost: GetMediaPosts_getMediaPosts_entities;
  className?: string;
  // Reserve the plain-<img> SSR path for above-the-fold cards only.
  priorityImageLoading?: boolean;
};

const MediaFeedListItem = ({
  mediaPost,
  className,
  priorityImageLoading = false,
}: MediaFeedListItemProp) => {
  const mediaFeedSlug = mediaPost.slug;
  const storeSlug = mediaPost.store.slug;

  const isVideo = mediaPost && 'video' in mediaPost;
  const mediaPostRoute = isVideo ? VIDEO_SOCIAL_MEDIA_POST : SOCIAL_MEDIA_POST;
  const link = `/${storeSlug}${mediaPostRoute}${mediaFeedSlug}`;
  const storeName = getStreamerName(mediaPost?.store);

  const thumbnailImage = isVideo
    ? mediaPost.thumbnailUrl || mediaPost.video.thumbnailUrl || ''
    : mediaPost.image.url || '';

  const mediaPostName =
    mediaPost.title?.length > 35
      ? `${mediaPost.title.slice(0, 35)}...`
      : mediaPost.title;

  const date = mediaPost?.scheduledAt
    ? getLocaleDate(mediaPost?.scheduledAt)
    : mediaPost?.createdAt
    ? getLocaleDate(mediaPost?.createdAt)
    : '';

  return (
    <ContentCard
      className={className}
      type={isVideo ? ContentType.VIDEO : ContentType.IMAGE}
      imageUrl={thumbnailImage}
      linkUrl={link}
      dateTime={date}
      isDateOnly
      hasBottomLabel={false}
      tzCode={mediaPost.scheduledAtTzCode || null}
      title={mediaPostName}
      user={storeName || ''}
      userUrl={mediaPost.store?.slug ? `/${mediaPost.store?.slug}` : ATHLETES}
      isPlay={isVideo}
      // First cards only: real CDN src in SSR HTML without next/image GIF shim.
      priorityImageLoading={priorityImageLoading}
    />
  );
};

export default MediaFeedListItem;
